import { useQuery } from '@apollo/client/react';
import { BLOG_AUTHOR_PAGE_QUERY } from '../../graphql/blog-queries';

export function useGetBlogAuthor(slug) {
    const { data, loading } = useQuery(BLOG_AUTHOR_PAGE_QUERY, { variables: { slug } });
    return { data, loading };
}
